export default __webpack_public_path__ + "static/media/feature1.82ae853a.png";